import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { SeasonContext } from "../../../store/SeasonContext";
import "./NewSeasonChecklist.css";
import { ModalContext } from "../../../store/ModalContext";
import InfoNavPanel from "../../../components/InfoNavPanel";

const NewSeasonChecklist = () => {
  const { checkboxes, toggleCheckbox } = useContext(SeasonContext);
  const { openModal, closeModal } = useContext(ModalContext);

  const infoPages = [
    {
      title: "Starting the new season",
      text: [
        "We recommend you to look at the Get Organized Checklist before starting the new season.",
        "You need to start the season before you can manage the **application periods** and the **activation and inactivation of subscriptions**.",
        "Once you click on 'Start New Season' you will be asked a series of questions to make sure you are ready. You can always click 'Go back' if you missed something.",
      ],
    },
    {
      title: "Starting the new season",
      text: [
        "You CANNOT update or delete **pickup locations** while in season.",
        "You CANNOT update or delete **subscriptions and tiers** during the season.",
        "You CANNOT update the **CSA delivery price** during the season.",
        "**IMPORTANT!** You should never end the season until after the last subscription is delivered. When you end the season, all CSA accounts get downgraded to social accounts. This means the delivery list will be deleted and CSA members lose access to their dashboard.",
      ],
    },
  ];

  function handleInfo() {
    openModal({
      body: (
        <InfoNavPanel
          infoPages={infoPages}
          lastPageAction={{ text: "Close", onClick: closeModal }}
        />
      ),
    });
  }

  return (
    <div className="list-new-season">
      <h3 className="new-season-checklist-header">
        Get organized before the new season! {"  "}
        <FontAwesomeIcon
          icon={faArrowDown}
          className="new-season-checklist-header"
        />
      </h3>
      <ul>
        <li>
          <label className="checklist-row">
            <input
              id="harvest-log-checkbox"
              type="checkbox"
              onChange={() => toggleCheckbox("printHarvestLogs")}
              checked={checkboxes["printHarvestLogs"]}
            />
            <Link className="checklist-item" to="/dashboard/admin/harvest-log">
              Print last season's harvest logs.{" "}
            </Link>
          </label>
        </li>
        <li>
          <label className="checklist-row">
            <input
              id="orders-checkbox"
              type="checkbox"
              onChange={() => toggleCheckbox("printOrders")}
              checked={checkboxes["printOrders"]}
            />
            <Link className="checklist-item" to="/dashboard/admin/orders">
              Print orders
            </Link>
          </label>
        </li>
        <li>
          <label className="checklist-row">
            <input
              id="pickup-locations-checkbox"
              type="checkbox"
              onChange={() => toggleCheckbox("updatePickupLocations")}
              checked={checkboxes["updatePickupLocations"]}
            />
            <Link
              className="checklist-item"
              to="/dashboard/admin/pickup-locations"
            >
              Update your Pickup Locations
            </Link>
          </label>
        </li>
        <li>
          <label className="checklist-row">
            <input
              id="csa-subs-and-tiers-checkbox"
              type="checkbox"
              onChange={() => toggleCheckbox("updateSubscriptionsAndTiers")}
              checked={checkboxes["updateSubscriptionsAndTiers"]}
            />
            <Link
              className="checklist-item"
              to="/dashboard/admin/csa-subscriptions"
            >
              Update Subscriptions and Tiers
            </Link>
          </label>
        </li>
        <li>
          <label className="checklist-row">
            <input
              id="csa-delivery-price-checkbox"
              type="checkbox"
              onChange={() => toggleCheckbox("updateCsaDeliveryPrice")}
              checked={checkboxes["updateCsaDeliveryPrice"]}
            />
            <Link
              className="checklist-item"
              to="/dashboard/admin/operation-controls"
            >
              Update CSA delivery price
            </Link>
          </label>
        </li>
      </ul>
      <div className="info-button">
        <button className="btn about-season-btn" onClick={handleInfo}>
          Info About New Season
        </button>
      </div>
    </div>
  );
};

export default NewSeasonChecklist;
